// import Vue from 'vue';
// import { API_URL } from '@/config';
// import router from '@/router';

export const person_fundings = {

  namespaced: true,

  state: {

  },

  getters: {

  },

  mutations: {

  },

  actions: {

  }
}
